var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{staticClass:"progress-container"},[_c('progress-linear')],1),_c('router-view'),_c('v-container',[_c('snack-bar')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }